var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-item-wrapper', {
    attrs: {
      "widget": _vm.widget
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.widget.options.hidden),
      expression: "!widget.options.hidden"
    }],
    staticClass: "sub-form-container"
  }, [_c('el-row', {
    staticClass: "header-row"
  }, [(_vm.leftActionColumn) ? _c('div', {
    staticClass: "action-header-column"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v(_vm._s(_vm.i18nt('render.hint.subFormAction')))]), _vm._v(" "), (!_vm.isReadMode) ? _c('el-button', {
    staticClass: "action-button",
    attrs: {
      "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
      "round": "",
      "type": "primary",
      "size": "mini",
      "title": _vm.i18nt('render.hint.subFormAddActionHint')
    },
    on: {
      "click": _vm.addSubFormRow
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18nt('render.hint.subFormAddAction'))), _c('i', {
    staticClass: "el-icon-plus el-icon-right"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.leftActionColumn && _vm.widget.options.showRowNumber) ? _c('div', {
    staticClass: "row-no-header-column"
  }, [_c('span', [_vm._v(_vm._s(_vm.i18nt('render.hint.subFormRowNo')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.widget.widgetList), function(subWidget) {
    return [(!subWidget.options.hidden) ? _c('div', {
      key: subWidget.id + 'thc',
      staticClass: "field-header-column",
      class: [_vm.getLabelAlign(_vm.widget, subWidget), !!subWidget.options.required ? 'is-required' : ''],
      style: ({
        width: subWidget.options.columnWidth
      })
    }, [(!!subWidget.options.labelIconClass) ? _c('span', {
      staticClass: "custom-label"
    }, [(subWidget.options.labelIconPosition === 'front') ? [(!!subWidget.options.labelTooltip) ? [_c('el-tooltip', {
      attrs: {
        "content": subWidget.options.labelTooltip,
        "effect": "light"
      }
    }, [_c('i', {
      class: subWidget.options.labelIconClass
    })]), _vm._v(_vm._s(subWidget.options.label))] : [_c('i', {
      class: subWidget.options.labelIconClass
    }), _vm._v(_vm._s(subWidget.options.label))]] : (subWidget.options.labelIconPosition === 'rear') ? [(!!subWidget.options.labelTooltip) ? [_vm._v("\n                " + _vm._s(subWidget.options.label)), _c('el-tooltip', {
      attrs: {
        "content": subWidget.options.labelTooltip,
        "effect": "light"
      }
    }, [_c('i', {
      class: subWidget.options.labelIconClass
    })])] : [_vm._v("\n                " + _vm._s(subWidget.options.label)), _c('i', {
      class: subWidget.options.labelIconClass
    })]] : _vm._e()], 2) : [_c('span', {
      attrs: {
        "title": subWidget.options.labelTooltip
      }
    }, [_vm._v(_vm._s(subWidget.options.label))])]], 2) : _vm._e()]
  }), _vm._v(" "), (!_vm.leftActionColumn) ? _c('div', {
    staticClass: "action-header-column"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v(_vm._s(_vm.i18nt('render.hint.subFormAction')))]), _vm._v(" "), (!_vm.isReadMode) ? _c('el-button', {
    staticClass: "action-button",
    attrs: {
      "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
      "round": "",
      "type": "primary",
      "size": "mini",
      "title": _vm.i18nt('render.hint.subFormAddActionHint')
    },
    on: {
      "click": _vm.addSubFormRow
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18nt('render.hint.subFormAddAction'))), _c('i', {
    staticClass: "el-icon-plus el-icon-right"
  })]) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.rowIdData), function(subFormRowId, sfrIdx) {
    return _c('el-row', {
      key: subFormRowId,
      staticClass: "sub-form-row"
    }, [(_vm.leftActionColumn) ? _c('div', {
      staticClass: "sub-form-action-column hide-label"
    }, [_c('div', {
      staticClass: "action-button-column"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-circle-plus-outline",
        "title": _vm.i18nt('render.hint.insertSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.insertSubFormRow(sfrIdx)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.deleteDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-delete",
        "title": _vm.i18nt('render.hint.deleteSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.deleteSubFormRow(sfrIdx)
        }
      }
    }), _vm._v(" "), (_vm.widget.options.showRowNumber) ? _c('span', {
      staticClass: "row-number-span"
    }, [_vm._v("#" + _vm._s(sfrIdx + 1))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.leftActionColumn && _vm.widget.options.showRowNumber) ? _c('div', {
      staticClass: "row-no-column"
    }, [(_vm.widget.options.showRowNumber) ? _c('span', {
      staticClass: "row-number-span"
    }, [_vm._v("#" + _vm._s(sfrIdx + 1))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.widget.widgetList), function(subWidget, swIdx) {
      return [(!subWidget.options.hidden) ? _c('div', {
        key: subWidget.id + 'tc' + subFormRowId,
        staticClass: "sub-form-table-column hide-label",
        style: ({
          width: subWidget.options.columnWidth
        })
      }, [_c(subWidget.type + '-widget', {
        key: _vm.fieldSchemaData[sfrIdx][swIdx].id,
        tag: "component",
        attrs: {
          "field": _vm.fieldSchemaData[sfrIdx][swIdx],
          "parent-list": _vm.widget.widgetList,
          "index-of-parent-list": swIdx,
          "parent-widget": _vm.widget,
          "sub-form-row-id": subFormRowId,
          "sub-form-row-index": sfrIdx,
          "sub-form-col-index": swIdx
        }
      })], 1) : _vm._e()]
    }), _vm._v(" "), (!_vm.leftActionColumn) ? _c('div', {
      staticClass: "sub-form-action-column hide-label"
    }, [_c('div', {
      staticClass: "action-button-column"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-circle-plus-outline",
        "title": _vm.i18nt('render.hint.insertSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.insertSubFormRow(sfrIdx)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.deleteDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-delete",
        "title": _vm.i18nt('render.hint.deleteSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.deleteSubFormRow(sfrIdx)
        }
      }
    })], 1)]) : _vm._e()], 2)
  })], 2)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cca3dec8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/container-item/sub-form-item.vue
// module id = null
// module chunks = 